import React from 'react';
import Throbber from 'mf-react-ui/Throbber';
import './ThrobberForPage.scss';

const ThrobberForPage = () => (
  <div className="page__throbber">
    <Throbber />
  </div>
);

export default ThrobberForPage;
